import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const PinCodeTimeInput = ({ value, onChange, label }) => {
  // Date 객체 생성 (value가 초 단위니까 * 1000)
  const dateValue = value ? new Date(value * 1000) : null;

  return (
    <div style={{ paddingTop: "30px" }}>
      <div>{label}</div>
      <DatePicker
        showTimeSelect
        timeIntervals={5}
        dateFormat="yyyy-MM-dd HH:mm"
        placeholderText={label}
        selected={dateValue}
        onChange={(date) => {
          if (date) {
            // UTC 기준 초(UNIX timestamp)로 변환
            onChange(Math.floor(date.getTime() / 1000));
          }
        }}
      />
    </div>
  );
};

export default PinCodeTimeInput;
